import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { format } from "date-fns";
import { putArmado } from "../../redux/actions/actionDocument";

export default function ProduccionCard({id, numberDocument, clientName, dateSend, dateReception}){
    const dispatch = useDispatch();
    

    const handleArmado = (e) => {
        console.log(e.target.value)
        const {value} = e.target; 
        dispatch(putArmado(value, numberDocument))
        setTimeout(() => {
           window.location.reload() 
        }, '1000');
    }


    return (
        <div className="flex flex-row text-[8pt]">
            <div className="w-14 text-center">{numberDocument}</div>
            <div className="w-60 pl-2">{clientName}</div>
            <div className="w-24 text-center">{dateSend ? format(new Date(dateSend), "dd/MM/yyyy") : null}</div>
            <div className="w-24 text-center">{dateReception ? format(new Date(dateReception), "dd/MM/yyyy") : null}</div>
            <div className="w-14 text-center"><button value={id} onClick={handleArmado}>Armado</button></div>
        </div>
    )

} 